@if (smartQuotes.length > 0) {
    <table
        sfTable
        striped
        [responsive]="true"
        small
        hover
        align="middle"
        style="min-width: 1000px; table-layout: fixed">
        <thead sfTableColor="light">
            <tr>
                <th class="text-center" style="width: 40px">Status</th>
                <th style="width: 200px">Name</th>
                <th style="width: 50px">Created</th>
                <th style="width: 100px">Created By</th>
                <th style="width: 50px" class="text-center">Order Status</th>
                <th style="width: 50px" class="text-end">Total</th>
                <th style="width: 60px"></th>
            </tr>
        </thead>
        <tbody>
            @for (quote of smartQuotes; track quote) {
                <tr>
                    <td class="text-center" style="width: 100px">
                        @if (quote.declined) {
                            <span class="badge bg-danger">Declined</span>
                        } @else if (quote.accepted && !quote.declined) {
                            <span class="badge text-bg-success">Accepted</span>
                        }
                        @if (!quote.accepted && !quote.declined) {
                            <span class="badge text-bg-warning">Pending</span>
                        }
                    </td>
                    <td [class.text-success]="quote.accepted">
                        <a class="fw-bold" routerLink="/customers/{{ quote.customer.id }}">{{
                            quote.customer.prettyName
                        }}</a>
                        <br />
                        <span class="text-body-secondary">{{ quote.customer.address }}</span>
                    </td>
                    <td>
                        <span sfDate [date]="quote.created"></span>
                    </td>
                    <td>
                        <sf-staff-inline [staff]="quote.createdBy"></sf-staff-inline>
                    </td>
                    <td class="text-center">
                        @if (quote.isOrdered) {
                            <span class="badge text-bg-success">Ordered</span>
                        } @else if (quote.accepted && !quote.isOrdered) {
                            <span class="badge text-bg-warning">Awaiting Order</span>
                        }
                    </td>
                    <td class="text-end">
                        @if (quote.freeOfCharge) {
                            <span class="badge text-bg-success">Free of Charge</span>
                        } @else {
                            {{ quote.total | currency }}
                        }
                    </td>
                    <td class="text-end">
                        <a
                            sfButton
                            [href]="quote.acceptanceUrl"
                            target="_blank"
                            color="primary"
                            tooltip="View acceptance"
                            tooltipContainer="body"
                            size="sm"
                            icon="external-link"></a>
                        <a
                            type="button"
                            sfButton
                            color="secondary"
                            tooltip="View the quote"
                            tooltipContainer="body"
                            size="sm"
                            icon="eye"
                            routerLink="/smartquote/{{ quote.id }}"></a>
                    </td>
                </tr>
            }
        </tbody>
    </table>
} @else {
    <p>There are no quotes based on the search criteria</p>
}
